/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 14:37:58
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-08 10:38:07
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { DefaultComponent } from './default/default.component';
import { PackComponent } from './pack/pack.component';
import { HeaderStatusComponent } from './header-status/header-status.component';

@NgModule({
  declarations: [DefaultComponent, HeaderComponent, PackComponent, HeaderStatusComponent],
  imports: [CommonModule],
  exports: [HeaderComponent, PackComponent, HeaderStatusComponent],
})
export class HeaderModule { }
